const Gallery = () => import('./Main')

const route = {
  path: '/gallery',
  name: 'gallery',
  meta: {
    title: 'Gallery - A D M A N 2 0 1 9'
  },
  component: Gallery
}

export default route
